/* tslint:disable */
/* eslint-disable */
export enum DictionaryEntryStatus {
  $0 = 0,
  $1 = 1,
  $2 = 2,
  $4 = 4,
  $8 = 8
}
